import React from "react";
import { Avatar, Typography } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

function stringToColor(str = "") {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i++) {
    color += `00${((hash >> (i * 8)) & 0xff).toString(16)}`.slice(-2);
  }
  return color;
}

const Comments = ({ comments = [] }) => {
  // Empty state
  if (!comments.length) {
    return (
      <div className="ec-comments-empty">
        <ChatBubbleOutlineIcon style={{ fontSize: 26, opacity: 0.3 }} />
        <Typography
          variant="body2"
          style={{ opacity: 0.5, marginTop: 6, fontFamily: "Nunito" }}
        >
          No comments yet — be the first to reply.
        </Typography>
      </div>
    );
  }

  // Comment list newest first
  return (
    <div className="ec-comments-list">
      {[...comments]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .map((item, idx) => {
          const firstName = item.user?.first_name || "Anonymous";
          const lastName = item.user?.last_name || "";
          const fullName = `${firstName} ${lastName}`.trim();
          const initials = firstName.charAt(0).toUpperCase();
          const avatarBg = stringToColor(fullName);

          const relativeTime = item.createdAt
            ? formatDistanceToNow(new Date(item.createdAt), { addSuffix: true })
            : "";

          return (
            <div key={item.id ?? idx} className="ec-comment-row">
              {/* Avatar photo or generated initials*/}
              <Avatar
                src={item.user?.avatarUrl || undefined}
                sx={{
                  width: 30,
                  height: 30,
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  bgcolor: avatarBg,
                  flexShrink: 0,
                }}
              >
                {initials}
              </Avatar>

              {/* Comment bubble */}
              <div className="ec-comment-body">
                <div className="ec-comment-meta">
                  <span className="ec-comment-author">{fullName}</span>
                  <span className="ec-comment-time">{relativeTime}</span>
                </div>
                <p className="ec-comment-text">{item.comment}</p>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default Comments;
